import { getApps, initializeApp } from "firebase/app";
import { browserSessionPersistence, getAuth, setPersistence } from "firebase/auth";
import { getFunctions } from "firebase/functions";

import { initializeAdminAppCheck } from "./appCheck";
import { configuration } from "./configuration";

import type { AppCheck } from "firebase/app-check";
import type { Auth } from "firebase/auth";
import type { Functions } from "firebase/functions";

let auth: Auth | null = null;
let functions: Functions | null = null;
let appCheck: AppCheck | null = null;
let persistence: Promise<void> | null = null;

const getApp = () => {
  if (!configuration.firebase) throw new Error("Canlı Firebase yapılandırması eksik.");
  return getApps().find((candidate) => candidate.name === "tayan-admin") ??
    initializeApp(configuration.firebase, "tayan-admin");
};

export const getAdminAuth = (): Auth => {
  if (!auth) {
    auth = getAuth(getApp());
    persistence = setPersistence(auth, browserSessionPersistence);
  }
  return auth;
};

export const waitForAdminAuth = async (): Promise<void> => {
  getAdminAuth();
  await persistence;
};

export const getAdminFunctions = (): Functions => {
  if (!functions) {
    const currentAuth = getAdminAuth();
    appCheck ??= initializeAdminAppCheck(getApp(), async () => {
      if (!currentAuth.currentUser) throw new Error("Yönetici oturumu bulunamadı.");
      return currentAuth.currentUser.getIdToken();
    });
    functions = getFunctions(getApp(), "us-central1");
  }
  return functions;
};
